import type { LucideProps } from 'lucide-react'

export function RagIcon({ className, ...props }: LucideProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <ellipse cx="12" cy="5" rx="9" ry="3" />
            <path d="M3 5V19A9 3 0 0 0 21 19V5" />
            <path d="M3 12A9 3 0 0 0 21 12" />
        </svg>
    )
}

export function RagIconGradient({ className, ...props }: LucideProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            {...props}
        >
            <defs>
                <linearGradient id="rag-icon-gradient" x1="3" y1="2" x2="21" y2="22" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#2563EB" /> {/* blue-600 */}
                    <stop offset="1" stopColor="#9333EA" /> {/* purple-600 */}
                </linearGradient>
            </defs>
            {/* Top Cylinder */}
            <ellipse cx="12" cy="5" rx="9" ry="3" fill="url(#rag-icon-gradient)" stroke="none" />
            <path d="M3 5v6a9 3 0 0 0 18 0v-6" fill="url(#rag-icon-gradient)" stroke="none" />

            {/* Bottom Cylinder */}
            <path d="M3 13v6a9 3 0 0 0 18 0v-6a9 3 0 0 1 -18 0" fill="url(#rag-icon-gradient)" stroke="none" />
        </svg>
    )
}
